"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Confetti = Confetti;
var _jsConfetti = _interopRequireDefault(require("js-confetti"));
var _reactSdk = require("@100mslive/react-sdk");
var _react = require("react");
var _reactUse = require("react-use");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var jsConfetti = new _jsConfetti["default"]();
var confettiMsgType = "CONFETTI";
var emojiCollections = {
  hearts: ["❤️", "😍", "♥️"],
  birthday: ["🎂", "🍰", "🎁"],
  yes: ["🙌", "✨", "🔥", "❤️"],
  no: ["🙅", "⛔", "❌"]
};

/**
 * This component shows a reference implementation of using [custom events](https://www.100ms.live/docs/javascript/v2/features/chat#custom-events).
 * One downside of the current implementation is that it doesn't take into account tab not in focus.
 * In this case multiple messages might accumulate leading to a lot of confetti when user comes back on the tab.
 */
function Confetti() {
  // https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
  var disableMotion = (0, _reactUse.useMedia)("(prefers-reduced-motion: reduce)");
  var onConfettiMsg = (0, _react.useCallback)(function (config) {
    if (!disableMotion) {
      jsConfetti.addConfetti(config);
    }
  }, [disableMotion]);
  var _useCustomEvent = (0, _reactSdk.useCustomEvent)({
      type: confettiMsgType,
      onEvent: onConfettiMsg
    }),
    sendEvent = _useCustomEvent.sendEvent;

  // e.g. sendConfetti(), sendConfetti({type: "hearts"}), sendConfetti({emojis: ["🔥"]})
  var sendConfetti = (0, _react.useCallback)(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      type = _ref.type,
      emojis = _ref.emojis;
    if (type && emojiCollections[type]) {
      emojis = emojiCollections[type];
    }
    sendEvent({
      emojis: emojis
    });
  }, [sendEvent]);

  // putting the function to send on window for quick access
  (0, _react.useEffect)(function () {
    window.sendConfetti = sendConfetti;
  }, [sendConfetti]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
}